// extracted by mini-css-extract-plugin
export var flexContainer = "SearchBar-module--flexContainer--9nX4+";
export var searchBox = "SearchBar-module--searchBox--KXR1f";
export var visuallyHidden = "SearchBar-module--visuallyHidden--+E9c-";